import { Injectable, inject } from '@angular/core';
import { ApiService } from '../../shared/services/api.service';
import { Observable, of, shareReplay } from 'rxjs';

export interface DialogInformation {
    id: string;
    title?: string;
    content?: string;
    footer?: string;
}


@Injectable({
    providedIn: 'root'
})
export class DialogInformationService {
    private apiService = inject(ApiService);
    private cache = new Map<string, Observable<any>>();

    public getDialogInformation(id: string): Observable<DialogInformation> {
        const key = `${id}-dialog`;
        if (!this.cache.has(key)) {
            this.cache.set(key, this.apiService.get<DialogInformation>(`/api/dialoginformation/${id}`)
                .pipe(shareReplay(1)));
        }
        return this.cache.get(key) ?? of({} as DialogInformation);
    }
}
